import { AiOutlineCloudUpload, AiOutlinePartition } from 'react-icons/ai';
import { FaUserCog } from 'react-icons/fa';
import { TbBuildingWarehouse, TbFaceIdError } from 'react-icons/tb';
import { GrVmMaintenance } from 'react-icons/gr';
import { TbAspectRatio } from 'react-icons/tb';
import { BsList } from 'react-icons/bs';
import { FcDataRecovery, FcOvertime } from 'react-icons/fc';
import { MdReceiptLong, MdRoomPreferences } from 'react-icons/md';
import { GiGears } from 'react-icons/gi';

const tiles = [
  {
    sNo: 3,
    link: '/common/masterListOfCriticalSparePart?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <TbBuildingWarehouse size="5rem" color="#a12222" />,
    p: 'Master List Of',
    span: 'Critical Spare Parts',
    isIcon: true,
  },
  {
    sNo: 5,
    link: '/admin/annualPreventivePlanNewTiles',
    isLink: true,
    icon: <GrVmMaintenance size="5rem" color="#343a40" />,
    p: 'Annual Preventive',
    span: 'MAINTENANCE Plan',
    isIcon: true,
  },
  {
    sNo: 6,
    link: '/admin/predictiveMaintenancePlanTiles',
    isLink: true,
    clauseNo: 4,
    icon: <GrVmMaintenance size="5rem" color="#343a40" />,
    p: 'Annual Predictive',
    span: 'Maintenance Plan',
    isIcon: true,
  },
  {
    sNo: 7,
    link: '/admin/createDownTimeAnalysisReport',
    isLink: true,
    icon: <FcOvertime size="5rem" color="#064a29" />,
    p: 'DOWN TIME',
    span: 'ANALYSIS REPORT',
    isIcon: true,
  },
  {
    sNo: 8,
    link: '/admin/createMttrAndMtbfReport',
    isLink: true,
    icon: <FcDataRecovery size="5rem" color="#064a29" />,
    p: 'MTTR & MTBF',
    span: 'REPORT',
    isIcon: true,
  },
  {
    sNo: 9,
    link: '/admin/mttrAndMtbfReport/dashboard',
    isLink: true,
    icon: <MdRoomPreferences size="5rem" color="#064a29" />,
    p: 'MTTR & MTBF',
    span: 'DASHBOARDS',
    isIcon: true,
  },
  {
    sNo: 10,
    link: '/admin/breakDownSlipList',
    isLink: true,
    icon: <MdReceiptLong size="5rem" color="#a12222" />,
    p: 'BREAK DOWN',
    span: 'SLIP',
    isIcon: true,
  },
  {
    sNo: 11,
    link: '/admin/masterListOfBreakdownList',
    isLink: true,
    icon: <TbFaceIdError size="5rem" color="#a12222" />,
    p: 'Master List of',
    span: 'Breakdown',
    isIcon: true,
  },
  {
    sNo: 12,
    link: '/admin/masterListOfLocationList?filter=createdAt',
    isLink: true,
    clauseNo: 4,
    icon: <GiGears size="5rem" color="#343a40" />,
    p: 'Master List Of',
    span: 'Location',
    isIcon: true,
  },
  // {
  //   sNo: 1,
  //   link: '/common/clauseUploadList?documentType=masterProcedureClause10&heading=MASTER PROCEDURE',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'MASTER',
  //   span: 'PROCEDURE',
  //   isIcon: true,
  // },
  // {
  //   sNo: 2,
  //   link: '/common/clauseUploadList?documentType=listOfPokaYokeClause10&heading=LIST OF POKA-YOKE',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'LIST OF',
  //   span: 'POKA-YOKE',
  //   isIcon: true,
  // },
  // {
  //   sNo: 3,
  //   link: '/common/clauseUploadList?documentType=crossCheckingOfPokaYokeClause10&heading=CROSS CHECKING OF POKA-YOKE',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'CROSS CHECKING OF',
  //   span: 'POKA-YOKE',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: '/common/clauseUploadList?documentType=pokaYokeFailureClause10&heading=POKA-YOKE FAILURE ANALYSIS',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'POKA-YOKE FAILURE',
  //   span: 'ANALYSIS',
  //   isIcon: true,
  // },
  // {
  //   sNo: 5,
  //   link: '/common/clauseUploadList?documentType=limitSampleAvailabilityClause10&heading=LIMIT SAMPLE AVAILABILITY',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'LIMIT SAMPLE',
  //   span: 'AVAILABILITY',
  //   isIcon: true,
  // },
  // {
  //   sNo: 6,
  //   link: '/common/clauseUploadList?documentType=visualDisplayOfStageClause10&heading=VISUAL DISPLAY OF OK AND NG AT WIP/FG STAGE',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'VISUAL DISPLAY OF OK AND',
  //   span: 'NG AT WIP/FG STAGE',
  //   isIcon: true,
  // },
  // {
  //   sNo: 4,
  //   link: '/common/clauseUploadList?documentType=pokaYokeFailureClause10&heading=POKA-YOKE FAILURE ANALYSIS',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <AiOutlineCloudUpload size="5rem" color="#135089" />,
  //   p: 'POKA-YOKE FAILURE',
  //   span: 'ANALYSIS',
  //   isIcon: true,
  // },
  // {
  //   sNo: 5,
  //   link: '/common/maintenance_breakdown',
  //   isLink: true,
  //   clauseNo: 10,
  //   icon: <TbBuildingWarehouse size="5rem" color="#a12222" />,
  //   // icon: <DomainDisabledIcon style={{ fontSize: '3rem', color: 'maroon' }} />,
  //   p: 'Maintenance',
  //   span: 'Module',
  //   isIcon: true,
  // },
  // {
  //   sNo: 6,
  //   link: '/common/instrumentTiles?filter=createdAt',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <GrVmMaintenance size="5rem" color="#343a40" />,
  //   p: ' Annual PM',
  //   span: 'Plan',
  //   isIcon: true,
  // },
  // {
  //   sNo: 7,
  //   link: '/common/annualPmPlanRotorCastingTiles?filter=createdAt',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <GrVmMaintenance size="5rem" color="#343a40" />,
  //   p: ' Annual PM',
  //   span: 'Plan',
  //   isIcon: true,
  // },
  // {
  //   sNo: 9,
  //   link: '/common/maintenanceLog',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <TbBuildingWarehouse size="5rem" color="#a12222" />,
  //   p: 'Maintenance',
  //   span: 'Log',
  //   isIcon: true,
  // },
  // {
  //   sNo: 10,
  //   link: '/common/appearanceplanMasterlist',
  //   isLink: true,
  //   icon: <TbAspectRatio size="5rem" color="#343a40" />,
  //   p: 'Master list of',
  //   span: 'Utilities',
  //   isIcon: true,
  // },
  // {
  //   sNo: 11,
  //   link: '/common/annualPmPlanUtilityTiles?filter=createdAt',
  //   isLink: true,
  //   clauseNo: 4,
  //   icon: <GrVmMaintenance size="5rem" color="#343a40" />,
  //   p: ' Annual PM',
  //   span: 'Plan (Utility)',
  //   isIcon: true,
  // },
  // {
  //   sNo: 11,
  //   link: '/common/appearanceplanMasterlist',
  //   isLink: true,
  //   icon: <TbAspectRatio size="5rem" color="#343a40" />,
  //   p: 'Master list of',
  //   span: 'Appearance',
  //   isIcon: true,
  // },
];

export default tiles;
